// ✅ src/data/servicesData.js

export const servicesData = [
  {
    id: 1,
    title: "Business Solutions",
    image: "../assets/services/experience.png",
    description: "Enhancing user and business experiences with cutting-edge solutions."
  },
  {
    id: 2,
    title: "Digital Transformation",
    image: "../assets/services/digital.png",
    description:
      "Empowering organizations to evolve digitally, enabling agility, scalability, and innovation in every business process."
  },
  {
    id: 3,
    title: "Digital Platforms",
    image: "../assets/services/platforms.png",
    description:
      "Developing scalable enterprise-grade platforms that accelerate your digital growth and streamline operations."
  },
  {
    id: 4,
    title: "ML & AI Innovations",
    image: "../assets/services/mlai.png",
    description:
      "Leverage Artificial Intelligence and Machine Learning to automate, predict, and optimize business decisions."
  },
  {
    id: 5,
    title: "Robotic Solutions",
    image: "../assets/services/robotics.png",
    description:
      "Integrating advanced robotics and automation systems to enhance productivity, safety, and precision."
  },
  {
    id: 6,
    title: "Turnkey Projects",
    image: "../assets/services/turnkey.png",
    description:
      "Delivering end-to-end technology implementations — from concept and design to deployment and support."
  },
  {
    id: 7,
    title: "Consulting",
    image: "../assets/services/consulting.png",
    description:
      "Providing strategic advisory, architecture guidance, and transformation roadmaps for enterprises."
  },
  {
    id: 8,
    title: "Data Services",
    image: "../assets/services/data.png",
    description:
      "Designing modern data architectures and analytics pipelines for actionable intelligence and insights."
  },
  {
    id: 9,
    title: "Process Automation",
    image: "../assets/services/automation.png",
    description:
      "Implementing intelligent automation to streamline workflows, reduce costs, and eliminate inefficiencies."
  },
  {
    id: 10,
    title: "Cloud Engineering",
    image: "../assets/services/cloud.png",
    description:
      "Modernize your infrastructure with secure, scalable cloud solutions — from migration to cloud-native development."
  },
  {
    id: 11,
    title: "Cybersecurity & Compliance",
    image: "../assets/services/cybersecurity.png",
    description:
      "Protect your digital assets with advanced security frameworks, monitoring, and compliance governance."
  },
  {
    id: 12,
    title: "IoT & Edge Computing",
    image: "../assets/services/iot.png",
    description:
      "Connect devices, sensors, and systems to drive smarter operations with Internet of Things and edge innovation."
  },
  {
    id: 13,
    title: "Advanced Analytics",
    image: "../assets/services/analytics.png",
    description:
      "Unlock business intelligence through predictive analytics, visualization, and real-time performance insights."
  }
];

// Industries Data
export const industriesData = [
  {
    id: 1,
    name: "Agriculture",
    image: "../assets/industries/agriculture.png",
    description:
      "Leveraging data-driven tools, IoT, and automation to increase productivity, precision, and sustainability in farming."
  },
  {
    id: 2,
    name: "Defense",
    image: "../assets/industries/defense.png",
    description:
      "Building secure, scalable, and mission-ready systems for defense, homeland security, and aerospace sectors."
  },
  {
    id: 3,
    name: "Automobile",
    image: "../assets/industries/automobile.png",
    description:
      "Accelerating innovation with connected vehicles, smart manufacturing, and mobility-as-a-service solutions."
  },
  {
    id: 4,
    name: "Energy",
    image: "../assets/industries/energy.png",
    description:
      "Driving digital energy transformation through smart grids, renewable integration, and predictive maintenance."
  }
];
